// extracted by mini-css-extract-plugin
export default {"wrapper":"Post_wrapper__CvM8F"};